import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from '../../../services/api';
import { LIST_RESPONSIBLE_EMAIL_TYPE_REQUEST } from '../../actions';
import {
  listResponsibleEmailTypeSuccess,
  listResponsibleEmailTypeError,
} from './actions';

function* listResponsibleEmailType() {
  try {
    const response = yield call(api.get, 'responsible-email-types');
    yield put(listResponsibleEmailTypeSuccess(response.data.data));
  } catch (error) {
    yield put(listResponsibleEmailTypeError(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(LIST_RESPONSIBLE_EMAIL_TYPE_REQUEST, listResponsibleEmailType),
  ]);
}
